import { Tab, TabProps, Tabs, Typography } from "@mui/material"
import { useEffect, useState } from "react";
import { Link as RouterLink, Outlet, useNavigate } from "react-router-dom"
import { useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { Item as ItemModel } from "@models/item";
import { ItemProvider } from "./ItemContext";
import { useErrorBoundary } from "react-error-boundary";
import { handleErrorWithBoundary } from "@shared/lib/errors"
import { useTheme } from "@emotion/react";
import { useGetItemByIdQuery } from "@features/tickets/api/items.api";


interface LinkTabProps extends TabProps {
  path: string;
  selected?: string;
}

function LinkTab(props: LinkTabProps) {
  return (
    <Tab
      component={RouterLink}
      to={props.path}
      label={props.label}
      aria-current={props.selected ? 'page' : undefined}
      {...props}
    />
  );
}

// Define an array of tab hrefs
const tabsData = [
  {
    label: "פרטי פריט",
    path: "",
  },
  {
    label: "תנועות",
    path: "journal-entries",
  },
];


function Item() {

  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const { showBoundary } = useErrorBoundary();

  const currentIndex = tabsData.findIndex(tab => tab.path !== "" && location.pathname.includes(tab.path));
  const value = currentIndex !== -1 ? currentIndex : 0;

 
  const [item, setItem] = useState<ItemModel | undefined>();
  const { id } = useParams();
  const { data: fetchedItem, error } = useGetItemByIdQuery(id ?? "", {
    skip: !id || Boolean(location.state),
  });


  useEffect(() => {
    if(location.state){
      setItem(location.state);
      navigate(location.pathname, { replace: true, state: null });
    }
  }, []);

  useEffect(() => {
    if (fetchedItem) {
      setItem(fetchedItem);
    }
  }, [fetchedItem]);

  useEffect(() => {
    if (error) {
      handleErrorWithBoundary(error, showBoundary);
    }
  }, [error, showBoundary]);

  {
    return item && 
    <>
      <div>
        <Typography variant="h5" component="span">
          כרטיס פריט
        </Typography>

        {/* <span>מס כרטיס: {item?.card_number}</span> */}
        <span>מס כרטיס: {item?.id}</span>
      </div>

      <Tabs
        dir='ltr'
        value={value}
        role="navigation"
        variant="scrollable"
        scrollButtons
        allowScrollButtonsMobile
        aria-label="scrollable force tabs example"
        style={{ direction: "rtl", flexDirection: "row-reverse", backgroundColor: theme.colors.section_color, padding: 5, marginTop: 20 }}

      >
        {tabsData.map((tab, index) => (
          <LinkTab key={index} label={tab.label} path={tab.path} />
        ))}

      </Tabs>
      <ItemProvider item={item}>
        <Outlet />
      </ItemProvider>
    </>
  }
}

export default Item